import moment from 'moment';

export function getWeek(date) {
  const monday = new Date(date);
  const saturday = new Date(date);
  const sunday = new Date(date);

  // subtract the day of the week from the date provided
  // this will return Monday
  const mondayDate = date.getDate() - (date.getDay() === 0 ? 6 : date.getDay() - 1);

  // set Monday's date
  monday.setDate(mondayDate);

  // saturday - add 5 days from monday
  saturday.setDate(mondayDate + 5);

  // sunday - add 6 days from monday
  sunday.setDate(mondayDate + 6);

  return {
    monday,
    saturday,
    sunday
  };
}

export function getRouteDefaultDates() {
  try {
    const currentWeek = getWeek(new Date());

    const monday = currentWeek.monday.toISOString().slice(0, 10);
    const sunday = currentWeek.saturday.toISOString().slice(0, 10);

    return {
      startDate: monday,
      endDate: sunday
    };
  } catch (ex) {
    return {
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString()
    };
  }
}

export function convertUtcToLocal(date, format) {
  try {
    return moment.utc(date).local().format(format);
  } catch (ex) {
    return `UTC ${date}`;
  }
}

export function formatDateObject(date, utc = false, local = false, newFormat = 'DD MMM YYYY HH:mm') {
  try {
    if (utc) {
      return local ? moment.utc(date).local().format(newFormat) : moment.utc(date).format(newFormat);
    } else {
      return local ? moment(date).local().format(newFormat) : moment(date).format(newFormat);
    }
  } catch (ex) {
    return date;
  }
}

// default datetime format YYYY-MM-DDTHH:mm:ssZZ
export function formatDateTime(date, utc = false, local = false, currentFormat = 'DD/MM/YYYY HH:mm:ss', newFormat = 'DD MMM YYYY HH:mm') {
  try {
    if (utc) {
      return local ? moment.utc(date, currentFormat).local().format(newFormat) : moment.utc(date, currentFormat).format(newFormat);
    } else {
      return local ? moment(date, currentFormat).local().format(newFormat) : moment(date, currentFormat).format(newFormat);
    }
  } catch (ex) {
    return date;
  }
}

export function formatUtcDateTime(date, format) {
  try {
    return moment.utc(date).format(format);
  } catch (ex) {
    return date;
  }
}

export function concatLocations(data, suburb = true, state = true, postcode = true) {
  let result = '';
  if (data.locationOne && data.locationOne.length > 0) {
    result += data.locationOne + ' ';
  }
  if (data.locationTwo && data.locationTwo.length > 0) {
    result += data.locationTwo + ' ';
  }
  if (data.locationThree && data.locationThree.length > 0) {
    result += data.locationThree + ' ';
  }
  if (data.locationFour && data.locationFour.length > 0) {
    result += data.locationFour + ' ';
  }
  if (data.locationFive && data.locationFive.length > 0) {
    result += data.locationFive + ' ';
  }
  if (suburb && data.suburb && data.suburb.length > 0) {
    result += data.suburb + ' ';
  }
  if (state && data.state && data.state.length > 0) {
    result += data.state + ' ';
  }
  if (postcode && data.postcode && data.postcode.length > 0) {
    result += data.postcode + ' ';
  }

  return result.trim();
}

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getReportAppName(appName) {
  let result = appName;
  let color = 'black';
  switch (appName) {
    case 'VUEBI':
      result = 'Vuebi';
      color = 'orange';
      break;
    case 'AGENCY':
      result = 'Agency';
      color = 'blue';
      break;
    case 'OIS':
    case 'MEDIAOWNER':
      result = 'OIS';
      color = 'purple';
      break;
    default:
      break;
  }

  return { name: result, color };
}

export function getReportName(name) {
  let result = name;

  switch (name) {
    case 'INSPECT':
      result = 'Inspection';
      break;
    case 'SQABASELINE':
      result = 'Baseline';
      break;
    case 'INSTALL':
      result = 'Installation';
      break;
    case 'REMOVE':
      result = 'Takedown';
      break;
    default:
      break;
  }

  return result;
}

export const thumbnailHandler = (event, itemMedia) => {
  const emptyImage = process.env.STATIC_URL + 'images/empty.png';

  if (event.target.src === emptyImage) {
    return;
  }

  if (event.target.src === itemMedia) {
    event.target.src = emptyImage;
  } else {
    event.target.src = itemMedia;
  }
};
